import { render, staticRenderFns } from "./CompanyCrudTable.vue?vue&type=template&id=2042b1e4&scoped=true"
import script from "./CompanyCrudTable.vue?vue&type=script&lang=js"
export * from "./CompanyCrudTable.vue?vue&type=script&lang=js"
import style0 from "./CompanyCrudTable.vue?vue&type=style&index=0&id=2042b1e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.21_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_tjpztcs3aockkrmwoqc6dtxv4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2042b1e4",
  null
  
)

export default component.exports